export default __webpack_public_path__ + "bg_night_big.ec020ac.svg";